export const isMobileBrowser = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false
  }

  return /iphone|ipad|ipod|android/i.test(navigator.userAgent)
}
